import React from 'react';
import { Typography, Box, Avatar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import './PaymentTable.css';
import PaymentTableSkeleton from '../../../SkeletonEffect/PaymentTableSkeleton/PaymentTableSkeleton';

const UserRoleColor = {
  Learner: { color: '#6B60E7', bgcolor: '#F0EFFF', value: 'Learner' },
  Instructor: { color: '#BC8D00', bgcolor: '#FFF3CE', value: 'Instructor' },
};

const StatusColor = {
  Pending: { color: '#E0AD14', bgcolor: '#FFFCF2', value: 'Pending' },
  Failed: { color: '#E14949', bgcolor: '#FFF2F2', value: 'Failed' },
  Completed: { color: '#14B334', bgcolor: '#F2FAF3', value: 'Completed' },
};

export function PaymentTable({ data, isLoading = false }) {
  const navigate = useNavigate();

  const handleRowClick = id => {
    navigate(`/admin/payments/transactions-details/${id}`);
  };

  if (isLoading) {
    return <PaymentTableSkeleton />;
  }

  return (
    <Box className="payment-table-container">
      {!data || data.length === 0 ? (
        <Box className="payment-empty-state">
          <Typography className="payment-empty-text">No transactions available</Typography>
        </Box>
      ) : (
        <table className="payment-table">
          <thead>
            <tr>
              <th className="payment-th">Payment ID</th>
              <th className="payment-th">Name</th>
              <th className="payment-th">User Role</th>
              <th className="payment-th">Payment For</th>
              <th className="payment-th">Date</th>
              <th className="payment-th">Time</th>
              <th className="payment-th">Amount(Riyal)</th>
              <th className="payment-th">Status</th>
            </tr>
          </thead>
          <tbody>
            {data.map(row => (
              <tr
                key={row.paymentId}
                className="payment-row"
                onClick={() => handleRowClick(row.paymentId)}
              >
                <td className="payment-td">
                  <span className="payment-id" data-full-id={row.apsPaymentId}>
                    {row.apsPaymentId ? row.apsPaymentId : row.paymentId}
                  </span>
                </td>
                <td className="payment-td">
                  <Box className="payment-user-cell">
                    <Avatar src={row.userImage} sx={{ width: 25, height: 25 }} />
                    <Typography className="payment-name-text">{row.name}</Typography>
                  </Box>
                </td>
                <td className="payment-td">
                  <Box
                    className="payment-role-badge"
                    sx={{
                      backgroundColor: UserRoleColor[row.userRole]?.bgcolor,
                      color: UserRoleColor[row.userRole]?.color,
                      borderColor: UserRoleColor[row.userRole]?.color,
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: '12px',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: 'normal',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {UserRoleColor[row.userRole]?.value || '---'}
                    </Typography>
                  </Box>
                </td>
                <td className="payment-td">{row.paymentFor}</td>
                <td className="payment-td">{dayjs(row.dateTime).format('DD-MM-YYYY')}</td>
                <td className="payment-td">{dayjs(row.dateTime).format('HH:mm')}</td>
                <td
                  className={`payment-td ${row.amount > 0 ? 'amount-positive' : 'amount-negative'}`}
                >
                  {row.amount > 0 ? `+${row.amount}` : row.amount}
                </td>
                <td className="payment-td">
                  <Box
                    className="payment-status-badge"
                    sx={{
                      border: `1px solid ${StatusColor[row.status]?.color || '#949DA6'}`,
                      backgroundColor: StatusColor[row.status]?.bgcolor || '#F8F9FA',
                      color: StatusColor[row.status]?.color || '#949DA6',
                    }}
                  >
                    <Box
                      className="payment-status-dot"
                      sx={{
                        backgroundColor: StatusColor[row.status]?.color || '#949DA6',
                      }}
                    />
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: '12px',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: 'normal',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {StatusColor[row.status]?.value || row.status}
                    </Typography>
                  </Box>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Box>
  );
}
